// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 783) return "css/783.powsterWebsite.css?v=2fc780dc6973c2dfa308";
	if (chunkId === 792) return "css/792.powsterWebsite.css?v=dfff7969512c7d226b59";
	if (chunkId === 594) return "css/594.powsterWebsite.css?v=20309964c33141d3e209";
	if (chunkId === 739) return "css/739.powsterWebsite.css?v=7825fc29f6d15af20ce7";
	if (chunkId === 353) return "css/353.powsterWebsite.css?v=63390a8a59ad4f89f870";
	if (chunkId === 80) return "css/80.powsterWebsite.css?v=574ce5693ac5cb7e3eaf";
	if (chunkId === 983) return "css/983.powsterWebsite.css?v=bbe1d81223b74ffbdc4a";
	if (chunkId === 182) return "css/182.powsterWebsite.css?v=99124a2284854bc5e257";
	// return url for filenames based on template
	return undefined;
};